import React from "react"
import { Routes, Route } from "react-router-dom"
import { SCREENS_DETAILS } from "./util/StaticData"
import App from "./App"
import AuthResponse from "./components/AuthResponse"
import Monitor from "./features/Monitor/Monitor"
import DataMetaData from "./features/DataMetadata/DataMetaData"
import { MainLayout } from "./components/MainLayout"
import { CommonWrapper } from "./components/CommonWrapper"
import { BreadCrumbWrapper } from "./components/BreadCrumbWrapper"
import { Maintenance } from "./features/Maintenance/Maintenance"
import { ModelMetaData } from "./features/Modeldata/ModelMetaData"
import Harmonization from "./features/Harmonization/Harmonization"
import Quality from "./features/Quality/Quality"
import { IssueTracker } from "./features/IssueTracker/IssueTracker"
import HarmonizationScenarioList from "./features/Harmonization/HarmonizationScenarioList"
import MappingComp from "./features/Harmonization/MappingComp"
import MappingInsights from "./features/Harmonization/mapping/MappingInsights"

export function AppRoutes() {
  return (
    // Main layout that wraps all routes
    <MainLayout>
      <Routes>
        {/* Route for the home page */}
        <Route
          path="/"
          element={
            <CommonWrapper>
              <App />
            </CommonWrapper>
          }
        />

        {/* Route for handling authentication response */}
        <Route
          path="/auth-response"
          element={
            <CommonWrapper>
              <AuthResponse />
              {/* Component to handle authentication response */}
            </CommonWrapper>
          }
        />

        {/* Route for the Monitoring screen */}
        <Route
          path={SCREENS_DETAILS.MONITORING}
          element={
            <CommonWrapper>
              <Monitor /> {/* Component for monitoring functionality */}
            </CommonWrapper>
          }
        />

        {/* Route for Data Metadata screen */}
        <Route
          path={SCREENS_DETAILS.DATA_METADATA}
          element={
            <CommonWrapper>
              <BreadCrumbWrapper>
                <DataMetaData /> {/* Component for displaying data metadata */}
              </BreadCrumbWrapper>
            </CommonWrapper>
          }
        />

        {/* Route for Maintenance screen */}
        <Route
          path={SCREENS_DETAILS.MAINTENANCE}
          element={
            <CommonWrapper>
              <Maintenance /> {/* Component for maintenance-related actions */}
            </CommonWrapper>
          }
        />

        {/* Route for Model Metadata screen */}
        <Route
          path={SCREENS_DETAILS.MODEL_META_DATA}
          element={
            <CommonWrapper>
              <BreadCrumbWrapper>
                <ModelMetaData /> {/* Component for model metadata */}
              </BreadCrumbWrapper>
            </CommonWrapper>
          }
        />

        <Route path={`${SCREENS_DETAILS.ISSUE_TRACKER}`}>
          <Route
            index
            element={
              <CommonWrapper>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "82vh",
                    gap: "12px",
                    marginTop: "12px",
                  }}
                >
                  <IssueTracker></IssueTracker>
                </div>
              </CommonWrapper>
            }
          />
        </Route>
        <Route
          path={SCREENS_DETAILS.MODEL_META_DATA}
          element={
            <CommonWrapper>
              <BreadCrumbWrapper>
                <ModelMetaData />
              </BreadCrumbWrapper>
            </CommonWrapper>
          }
        />
        <Route path={`${SCREENS_DETAILS.DATA_HARMONIZATION}`}>
          <Route
            index
            element={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "90vh",
                }}
              >
                <CommonWrapper>
                  <Harmonization>
                    <HarmonizationScenarioList />
                  </Harmonization>
                </CommonWrapper>
              </div>
            }
          />
        </Route>
        <Route path={`${SCREENS_DETAILS.CREATE_SCENARIO}`}>
          <Route
            index
            element={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "90vh",
                }}
              >
                <CommonWrapper>
                  <Harmonization>
                    <MappingComp />
                  </Harmonization>
                </CommonWrapper>
              </div>
            }
          />
          <Route
            path=":id"
            element={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "90vh",
                }}
              >
                <CommonWrapper>
                  <Harmonization>
                    <MappingComp />
                  </Harmonization>
                </CommonWrapper>
              </div>
            }
          />
        </Route>
        <Route path={`${SCREENS_DETAILS.MAPPING_INSIGHTS}`}>
          <Route
            index
            element={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "90vh",
                }}
              >
                <CommonWrapper>
                  <Harmonization>
                    <MappingInsights />
                  </Harmonization>
                </CommonWrapper>
              </div>
            }
          />
        </Route>
        <Route path={`${SCREENS_DETAILS.DATA_QUALITY}`}>
          <Route
            index
            element={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "90vh",
                }}
              >
                <CommonWrapper>
                  <Quality></Quality>
                </CommonWrapper>
              </div>
            }
          />
        </Route>
      </Routes>
    </MainLayout>
  )
}
